import AppNavbar from './AppNavbar'
import AppFooter from './AppFooter'
import AppPagination from './AppPagination'
import PositionList from './PositionList'
import DateFilterInput from './DateFilterInput'
import ResultCount from './ResultCount'
import ConditionCheckboxGroup from './ConditionCheckboxGroup'
import EntriesLanding from './EntriesLanding'
import SkillTabCheckboxGroup from './SkillTabCheckboxGroup'
import MultiSelectPopupField from './MultiSelectPopupField'
import AccountHeader from './AccountHeader'
import ChipToggleGroup from './ChipToggleGroup'
import AdminJobApplicationTable from './AdminJobApplicationTable'
import AdminUserTable from './AdminUserTable'
import JobApplicationList from './JobApplicationList'
import JobApplicationDetail from './JobApplicationDetail'
import InterviewSlotPicker from './InterviewSlotPicker'
import JobApplicationWithdrawButton from './JobApplicationWithdrawButton'
import AdminJobApplicationSummary from './AdminJobApplicationSummary'
import AdminJobApplicationTransitionForm from './AdminJobApplicationTransitionForm'
import AdminJobApplicationHistory from './AdminJobApplicationHistory'
import AdminInterviewForm from './AdminInterviewForm'
import AdminInterviewSummary from './AdminInterviewSummary'
import AdminInterviewHistory from './AdminInterviewHistory'
import AuthCard from './AuthCard'
import AvatarField from './AvatarField'
import FilePickerField from './FilePickerField'
import FormActions from './FormActions'
import AdminDashboard from './AdminDashboard'
import AdminReferralRegistrations from './AdminReferralRegistrations'

// data-react-component="ComponentName" な要素にこのコンポーネントがマウントされる
export const registry = {
  AppNavbar,
  AppFooter,
  AppPagination,
  PositionList,
  DateFilterInput,
  ResultCount,
  ConditionCheckboxGroup,
  EntriesLanding,
  SkillTabCheckboxGroup,
  MultiSelectPopupField,
  AccountHeader,
  ChipToggleGroup,
  AdminJobApplicationTable,
  AdminUserTable,
  JobApplicationList,
  JobApplicationDetail,
  InterviewSlotPicker,
  JobApplicationWithdrawButton,
  AdminJobApplicationSummary,
  AdminJobApplicationTransitionForm,
  AdminJobApplicationHistory,
  AdminInterviewForm,
  AdminInterviewSummary,
  AdminInterviewHistory,
  AuthCard,
  AvatarField,
  FilePickerField,
  FormActions,
  AdminDashboard,
  AdminReferralRegistrations,
}
